module.exports = __webpack_public_path__ + "static/media/Dayly_ios_3.fcc694a2.jpg";